import { createSlice } from '@reduxjs/toolkit';
import { Algolia } from 'types/currentEvent';

// initial state
const initialState: Algolia = {
  allEvents: null,
  allContacts: null,
  allVenues: null,
  algoliaLoading: false
};

// ==============================|| SLICE - ALGOLIA ||============================== //

const algolia = createSlice({
  name: 'algolia',
  initialState,
  reducers: {
    setAllEvents(state, action) {
      state.allEvents = action.payload.allEvents;
    },
    setAllContacts(state, action) {
      state.allContacts = action.payload.allContacts;
    },
    setAllVenues(state, action) {
      state.allVenues = action.payload.allVenues;
    },
    setAlgoliaLoading(state, action) {
      state.algoliaLoading = action.payload;
    }
  }
});

export default algolia.reducer;

export const { setAllEvents, setAllContacts, setAllVenues, setAlgoliaLoading } = algolia.actions;
